module.exports = __webpack_public_path__ + "img/collage.83f7fc7b.webp";